import React from "react";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import "./Legal.css";

const Impressum = () => {
  return (
    <div>
      <Breadcrumbs title="Impressum" />
      <div className="container py-16">
        <div className="legal-content">
          <h2>Impressum</h2>
          <h3>Angaben gemäß § 5 TMG</h3>
          <p>
            Digitale Zahnpraxis Dr. Alshoutaiui<br />
            Roseggerstraße 23<br />
            5020 Salzburg<br />
            Austria
          </p>
          <h3>Kontakt</h3>
          <p>
            Telefon: +43 662 432 330<br />
            E-Mail: <a href="mailto:office@digitalezahnpraxis.at">office@digitalezahnpraxis.at</a>
          </p>
          <h3>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h3>
          <p>
            Dr. Alshoutaiui<br />
            Roseggerstraße 23<br />
            5020 Salzburg<br />
            Austria
          </p>
          <h3>Haftungsausschluss</h3>
          <p>
            Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
          </p>
          <h3>Haftung für Links</h3>
          <p>
            Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
          </p>
          <h3>Urheberrecht</h3>
          <p>
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem österreichischen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Impressum;
